module.exports = __webpack_public_path__ + "img/tag_black_pin.c5377b9a.svg";